// FastMaxLanding.jsx
// Route: /
// Assembles: MarketplaceHeader + ComboHero + CategoriesRow + ProductGrid + MarketplaceFooter

import React from "react";
import { MarketplaceHeader }  from "./shared/MarketplaceHeader";
import { MarketplaceFooter }  from "./shared/MarketplaceFooter";
import { WhatsAppFloat }      from "./shared/WhatsAppFloat";
import { ComboHero }          from "./marketplace/ComboHero";
import { CategoriesRow }      from "./marketplace/CategoriesRow";
import { ProductGrid }        from "./marketplace/ProductGrid";

export default function FastMaxLanding() {
  return (
    <div className="min-h-screen bg-slate-50 font-sans antialiased text-slate-900 flex flex-col">
      <MarketplaceHeader />

      <main className="flex-1">
        <ComboHero />
        <ProductGrid />
      </main>

      <MarketplaceFooter />
      <WhatsAppFloat />
    </div>
  );
}